import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import matchSorter from 'match-sorter';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export class DraftTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // data: makeData(
      ranking: 'iss',
      sorted: [{ id: '14' }],
      columns: []
    };
  }

  getColumns(cols, ranking) {
    console.log(cols, ranking, Object.keys(cols));
    let newColumns = [];
    Object.keys(cols).map((key, value) => {
      if (
        ['biographical', 'henri', 'lastSeasonStats', 'rankings'].includes(key)
      ) {
        if (key === 'biographical') {
          let cols = [
            {
              Header: 'Player',
              accessor: d => d[key].firstName + ' ' + d[key].lastName,
              id: '0',
              defaultSortDesc: false,
              minWidth: 140,
              filterMethod: (filter, row) => {
                return row[filter.id].toLowerCase().includes(filter.value);
              }
            },
            {
              Header: 'POS',
              id: '1',
              minWidth: 50,
              accessor: d => d[key].position,
              defaultSortDesc: false
            },
            {
              Header: 'Team',
              id: '2',
              minwidth: 140,
              accessor: d => d[key].currentTeam,
              defaultSortDesc: false
            },
            {
              Header: 'League',
              id: '3',
              minWidth: 70,
              accessor: d => d[key].currentLeague,
              defaultSortDesc: false
            },
            {
              Header: 'Age',
              id: '4',
              minWidth: 50,
              accessor: d => d[key].currentAge,
              defaultSortDesc: false
            },
            {
              Header: 'Height',
              id: '5',
              minWidth: 50,
              accessor: d => d[key].height
            },
            {
              Header: 'Weight',
              id: '6',
              minWidth: 50,
              accessor: d => d[key].weight
            }
          ];
          newColumns.push(
            cols[0],
            cols[1],
            cols[2],
            cols[3],
            cols[4],
            cols[5],
            cols[6]
          );
        } else if (key === 'lastSeasonStats') {
          let cols = [
            {
              Header: 'GP',
              id: '7',
              accessor: d => d[key].gp,
              minWidth: 50
            },
            {
              Header: 'G',
              id: '8',
              accessor: d => d[key].g,
              minWidth: 50
            },
            {
              Header: 'A',
              id: '9',
              accessor: d => d[key].a,
              minWidth: 50
            },
            {
              Header: 'P',
              id: '10',
              minWidth: 50,
              accessor: d => d[key].p
            },
            {
              Header: 'PIM',
              id: '11',
              minWidth: 50,
              accessor: d => d[key].pim
            },
            {
              Header: 'TO %',
              id: '12',
              minWidth: 60,
              accessor: d => (d[key] ? +(d[key].toPct * 100).toFixed(2) : null)
            }
          ];
          newColumns.push(cols[0], cols[1], cols[2], cols[3], cols[4], cols[5]);
        } else if (key === 'henri') {
          newColumns.push({
            Header: 'HENRI',
            id: '13',
            minWidth: 60,
            accessor: d => d[key]
          });
        } else if (key === 'rankings') {
          if (ranking === 'iss') {
            newColumns.push({
              Header: 'ISS',
              id: '14',
              accessor: d => d[key].iss,
              minWidth: 60,
              defaultSortDesc: false
            });
          } else if (ranking === 'mckeens') {
            newColumns.push({
              Header: "McKeen's",
              id: '14',
              accessor: d => d[key].mckeens,
              minWidth: 60,
              defaultSortDesc: false
            });
          } else if (ranking === 'futureConsiderations') {
            newColumns.push({
              Header: 'Future',
              id: '14',
              accessor: d => d[key].futureConsiderations,
              minWidth: 60,
              defaultSortDesc: false
            });
          } else if (ranking === 'hockeyProspect') {
            newColumns.push({
              Header: 'Prospect',
              id: '14',
              accessor: d => d[key].hockeyProspect,
              minWidth: 60,
              defaultSortDesc: false
            });
          } else if (ranking === 'nhlCentralNA') {
            newColumns.push({
              Header: 'NHL NA',
              id: '14',
              accessor: d => d[key].nhlCentralNA,
              minWidth: 60,
              defaultSortDesc: false
            });
          } else if (ranking === 'nhlCentralEU') {
            newColumns.push({
              Header: 'NHL EU',
              id: '14',
              accessor: d => d[key].nhlCentralEU,
              minWidth: 60,
              defaultSortDesc: false
            });
          }
        }
      } else {
        return { show: false };
        // this.setState({columns:  })
      }
    });
    console.log(newColumns);
    newColumns.sort(function(a, b) {
      return a.id - b.id;
    });
    return newColumns;
  }

  componentDidMount() {
    let cols = this.getColumns(this.props.prospects[0], this.state.ranking);
    this.setState({ columns: cols });
  }

  handleChange(e, id) {
    this.refs.draftTable.filterColumn(this.state.columns[id], e.target.value);
  }
  changeRanking(e) {
    let cols = this.getColumns(this.props.prospects[0], e.target.value);
    this.setState({ columns: cols });
  }

  render() {
    //  //console.log('first' + JSON.stringify(this.props.prospects[0]));

    return (
      <div>
        <div
          style={{
            display: 'flex',
            color: '#4f738e',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <input
            onChange={e => this.handleChange(e, 0)}
            placeholder={'Search Players'}
            style={{ margin: '1em 0' }}
          />
          <div>
            <strong>League:</strong>
            <select onChange={e => this.handleChange(e, 3)} class="filter">
              <option value="">All</option>
              <option value="OHL">OHL</option>
              <option value="WHL">WHL</option>
              <option value="QMJHL">QMJHL</option>
              <option value="BCHL">BCHL</option>
              <option value="USHS-Prep">USHS-Prep</option>
              <option value="USHL">USHL</option>
              <option value="USDP">USDP</option>
              <option value="NCAA">NCAA DIV I</option>
              <option value="NAHL">NAHL</option>
              <option value="SuperElit">J20 SuperElit</option>
              <option value="Liiga">Liiga</option>
              <option value="SHL">SHL</option>
              <option value="MHL">MHL</option>
              <option value="Czech U18">Czech U18</option>
              <option value="Czech U20">Czech U20</option>
              <option value="AJHL">AJHL</option>
              <option value="Allsvenskan">Allsvenskan</option>
              <option value="Jr. A SM-liiga">Jr. A SM-liiga</option>
            </select>
          </div>
          <div>
            <strong>Position:</strong>
            <select onChange={e => this.handleChange(e, 1)} class="filter">
              <option value="">All</option>
              <option value="C">C</option>
              <option value="LW">LW</option>
              <option value="RW">RW</option>
              <option value="D">D</option>
              <option value="G">G</option>
            </select>
          </div>
          <div>
            <strong>Rating Service:</strong>
            <select onChange={e => this.changeRanking(e)} class="filter">
              <option value="nhlCentralNA">NHL Central Scouting NA</option>
              <option value="nhlCentralEU">NHL Central Scouting EU</option>
              <option value="hockeyProspect">Hockey Prospect</option>
              <option value="iss" selected>
                ISS
              </option>
              <option value="mckeens">McKeen's</option>
              <option value="futureConsiderations">
                Future Considerations
              </option>
            </select>
          </div>
        </div>
        <ReactTable
          toggleActive={this.props.toggleActive}
          data={this.props.prospects}
          ref="draftTable"
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) == filter.value
          }
          getTrProps={(state, rowInfo, column, instance, data) => ({
            onClick: () => {
              {
                this.props.toggleActive(
                  instance.props.data[rowInfo.index].playerID
                );
              }
            }
          })}
          sorted={this.state.sorted}
          onSortedChange={sorted => {
            this.setState({ sorted });
          }}
          defaultSortDesc={true}
          defaultSortMethod={(a, b, desc) => {
            a = a === null ? (desc ? -Infinity : Infinity) : a;
            b = b === null ? (desc ? -Infinity : Infinity) : b;
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            return 0;
          }}
          columns={this.state.columns}
          resizable={false}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/DraftTable.js